import React, { forwardRef, InputHTMLAttributes } from 'react'
import type { Ref } from 'react'
import clsx from 'clsx'

export type RadioProps = InputHTMLAttributes<HTMLInputElement>

/**
 * Primary UI component for user interaction
 */
function Radio(props: RadioProps, ref: Ref<HTMLInputElement>): JSX.Element {
  const {
    /**
     * Is this the principal call to action on the page?
     */
    className,
    placeholder,
    ...rest
  } = props
  const { id } = rest
  const base = 'radio'
  const cn = clsx(base, className)

  return (
    <div className={cn}>
      <input className={`${base}__input`} type='radio' ref={ref} {...rest} />
      <label className={`${base}__label`} htmlFor={id}>
        {placeholder}
      </label>
    </div>
  )
}

export default forwardRef(Radio)
